import Chart from 'chart.js'
import { pathOr } from 'ramda'

Chart.defaults.global.defaultFontColor = '#000000'
Chart.defaults.global.defaultFontFamily = 'Roboto'
Chart.defaults.global.defaultFontSize = 14

Chart.pluginService.register({
  id: 'doughnutCircleText',
  beforeDraw: function (chart) {
    var width = chart.chart.width
    var height = chart.chart.height
    var ctx = chart.chart.ctx

    ctx.restore()
    var fontSize = (height / 114).toFixed(2)
    ctx.font = fontSize + 'em sans-serif'
    ctx.textBaseline = 'middle'

    var htext = pathOr('', ['config', 'options', 'doughnutCircleText', 'heading'], chart)
    var htextX = Math.round((width - ctx.measureText(htext).width) / 2)
    var htextY = height * 0.4
    ctx.fillText(htext, htextX, htextY)
    ctx.save()

    ctx.restore()
    fontSize = (height / 182).toFixed(2)
    ctx.font = fontSize + 'em sans-serif'
    var ttext = pathOr('', ['config', 'options', 'doughnutCircleText', 'title'], chart)
    var ttextX = Math.round((width - ctx.measureText(ttext).width) / 2)
    var ttextY = height * 0.6
    ctx.fillText(ttext, ttextX, ttextY)
    ctx.save()

    ctx.restore()
    // fontSize = (height / 182).toFixed(2)
    // ctx.font = fontSize + 'em sans-serif'
    var stext = pathOr('', ['config', 'options', 'doughnutCircleText', 'subtitle'], chart)
    var stextX = Math.round((width - ctx.measureText(stext).width) / 2)
    var stextY = height * 0.7
    ctx.fillText(stext, stextX, stextY)
    ctx.save()
  }
})
